import imageLoader from '../../lib/imageLoader';
import { Analytics } from '@plaudit/analytics';

const myAnalytics: Analytics = Analytics.getInstance();

export default class Product {
	private imageFrameClass = 'product__media';
	private imageClass = 'product__image';
	private thumbClass = 'product__thumb';
	private variantSelectorClass = 'product__variant';
	private imageFrameEl: HTMLDivElement;
	private imageEl: HTMLImageElement;
	private thumbEl: HTMLCollectionOf<HTMLAnchorElement>;
	private variantSelectorEl: HTMLCollectionOf<HTMLAnchorElement>;

	constructor() {
		this.imageFrameEl = document.getElementsByClassName(this.imageFrameClass)[0] as HTMLDivElement;
		if (!this.imageFrameEl)
			return;

		this.imageEl = this.imageFrameEl.getElementsByClassName(this.imageClass)[0] as HTMLImageElement;
		this.thumbEl = this.imageFrameEl.getElementsByClassName(this.thumbClass) as HTMLCollectionOf<HTMLAnchorElement>;
		this.variantSelectorEl = document.getElementsByClassName(this.variantSelectorClass) as HTMLCollectionOf<HTMLAnchorElement>;

		this.bindHandlers();
	}
    
    private updateImage(srcUrl: string): void {
        this.imageEl.src = srcUrl;
    }

	private clickHandler = (event: Event): void => {
		event.preventDefault();

		const element: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;

		if (element.href !== this.imageEl.src) {
            this.updateImage(element.href);
            /* Active state is needed for proper styling */
            for (let i: number = 0; i < this.thumbEl.length; i++){
                this.thumbEl[i].removeAttribute('active');
            }
            element.setAttribute('active', '');
            /* GA */myAnalytics.trackEvent('Product Gallery', 'Select', element.title);
		}
	}

    private bindHandlers(): void {
        for (let i: number = 0; i < this.thumbEl.length; i++) {
            const element: HTMLAnchorElement = this.thumbEl[i];
            element.addEventListener('click', this.clickHandler);
        }
        for (let i: number = 0; i < this.variantSelectorEl.length; i++) {
            const element: HTMLAnchorElement = this.variantSelectorEl[i];
            element.addEventListener('click', this.clickHandler);
            // element.addEventListener('mousenter', this.mouseInHandler);
            // element.addEventListener('mouseleave', this.mouseOutHandler);
        }
    }

	// TODO: We'd discussed whether to implement the hover effect, but I don't recall what we came down on. -SB 2017-11-13
	// private mouseInHandler = (event: Event): void => {
	// 	const element: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;

	// 	if (element.href !== this.prevImgSrc) {
	// 		this.prevImgSrc = this.updateImage(element.href);
	// 	}
	// }

	// private mouseOutHandler = (event: Event): void => {
	// 	const element: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;
	// 	this.updateImage(this.prevImgSrc);
	// }
}
